const BASE_URL = ((env = process.env.APP_ENV) => {
  switch (env) {
    case "dev":
    case "development": {
      return "https://dev.bruzz.be";
    }
    case "stag":
    case "staging": {
      return "https://stag.bruzz.be";
    }
    case "prod":
    case "production":
    default: {
      return "https://www.bruzz.be";
    }
  }
})();

const links = Array.from(
  document.querySelectorAll(`a[href*='bruzz.be/live/popup']`)
);

const openPopup = (type) => (e) => {
  e.preventDefault();
  /* It should be at least about 440px, since otherwise the Tidio (chat) function looks weird */
  return window.open(
    `${BASE_URL}/live/popup#${type}`,
    "popup",
    "width=440,height=710"
  );
};

links.map((link) => {
  const type =
    link.href.indexOf("#") !== -1
      ? link.href.substring(link.href.indexOf("#") + 1)
      : "listen";

  if (type) {
    return (link.onclick = openPopup(type));
  }

  return null;
});
